import { render } from "./DirectoryDetails.vue?vue&type=template&id=4590ed8f"
import script from "./DirectoryDetails.vue?vue&type=script&lang=js"
export * from "./DirectoryDetails.vue?vue&type=script&lang=js"

import "./DirectoryDetails.vue?vue&type=style&index=0&id=4590ed8f&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__